var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('daohang',{attrs:{"tabIndex":_vm.tabIndex},on:{"selected":_vm.xuanze}}),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.tabIndex==0)?_c('home'):_vm._e(),_vm._v(" "),(_vm.tabIndex==1)?_c('guanyu'):_vm._e(),_vm._v(" "),(_vm.tabIndex==2)?_c('lianxi'):_vm._e()],1),_vm._v(" "),_c('qkw-footer',{on:{"selected":_vm.xuanze}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-059660f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/index.vue
// module id = null
// module chunks = 